import { render, staticRenderFns } from "./Loykrathong.vue?vue&type=template&id=83f68d92&scoped=true&"
import script from "./Loykrathong.vue?vue&type=script&lang=js&"
export * from "./Loykrathong.vue?vue&type=script&lang=js&"
import style0 from "./Loykrathong.vue?vue&type=style&index=0&id=83f68d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f68d92",
  null
  
)

export default component.exports